import { render } from "./DeleteIcon.vue?vue&type=template&id=b1644fbc&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"

import "./DeleteIcon.vue?vue&type=style&index=0&id=b1644fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1644fbc"]])

export default __exports__